<template>
    <div
        :class="applicantTopBlockClasses(user.status)"
        v-if="user"
    >
        <div class="left-side">
            <div class="left-side-info">
                <div class="person-info-wrap">
                    <div class="person-info">
                        <div class="name">{{ user.name }} {{ user.last_name}}</div>
                        <div class="position">{{ user.position.title }}</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="right-side">
            <div class="contacts">
                <img src="/img/svg/icons-phone.svg" alt="">
                {{ user.cell_number }}
            </div>
            <div class="contacts">
                <img src="/img/svg/icons-email.svg" alt="email">
                <a :href="`mailto:${user.email}`" class="">{{ user.email }}</a>
            </div>
            <div class="contacts" v-if="user.user_address">
                <img src="/img/svg/icons-location.svg" alt="">
                {{ user.user_address.city }}, {{ user.user_address.state}}
            </div>
        </div>
    </div>
</template>

<script>

import StyleHandler from "../../../../../../resources/js/mixins/StyleHandler";

export default {
    name:'EmployeeInfoBlock',
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    mixins: [StyleHandler],
}

</script>

<style scoped>

</style>
